import * as Y from 'yjs';
import { SURFACES_ROOT } from './document-surfaces';

/**
 * Renames one surface in a document's manifest.
 *
 * Lives here rather than in `useSurfaceMutations` because the title bar
 * renames the surface it is heading, and `components/` cannot import from
 * `features/`. The mutations hook delegates to this so both callers write the
 * manifest exactly one way.
 *
 * An empty title is refused outright: a surface keeps the name it had. Unlike
 * a document, which falls back to 'Untitled', a surface's title is rendered
 * directly by the panel row and the breadcrumb, where an empty string reads as
 * a rendering bug rather than a choice.
 */
export function renameSurface(doc: Y.Doc | null, id: string, title: string): void {
  if (!doc) return;
  const trimmed = title.trim();
  if (trimmed === '') return;

  const root = doc.getArray<Y.Map<unknown>>(SURFACES_ROOT);
  for (let i = 0; i < root.length; i += 1) {
    const map = root.get(i);
    if (map.get('id') !== id) continue;
    doc.transact(() => {
      map.set('title', trimmed);
    });
    return;
  }
}
